import React, { useEffect } from 'react';
import { Icon, Grid, Message, Label } from 'semantic-ui-react';
import { t } from 'i18next';

import connect from 'react-redux/es/connect/connect';
import GridColumnInputWrapper from '../../common/GridColumnInputWrapper';
import { AccordionWrapper } from 'react-lib/dist/components-es';

import { chemicalProductsActions } from '../../../behavior/chemicalProducts/index';
import { VIEW_MODE, CREATE_MODE, entityType } from '../../../constants';
import { filterActions } from '../../../behavior/filter';
import CommonTagsInputWrapper from '../../common/CommonTagsInputWrapper';
import { getHazardIconPath } from '../../../utils';
import { initSelectors } from '../../../behavior/init';
import useUser from '@behavior/init/getUserV2';
import moment from 'moment';
import { defaultDateFormatJustDate } from 'Dates';

const CPSelectChemicalContainer = ({ ...props }) => {
  const { user } = useUser();
  const { mode } = props;

  useEffect(() => {
    const chemProdId = new URLSearchParams(window.location.search).get('chemProdId');
    if (mode === CREATE_MODE && chemProdId) {
      onProgrammaticallyChemicalProductChange(null, chemProdId);
    }
  }, [mode]);

  const onProgrammaticallyChemicalProductChange = (
    e,
    newChemicalProductSelectedId,
    isClone = false
  ) => {
    if (e) e.preventDefault();
    let { chemicalProduct } = props.values;
    chemicalProduct.selectedChemicalProduct = { id: newChemicalProductSelectedId };
    onChemicalProductChange(chemicalProduct.selectedChemicalProduct, isClone);
  };

  const onChemicalProductChange = (selectedChemicalProduct, isClone = false) => {
    if (isClone) props.getNewChemicalProductFromCurrent(props.values.chemicalProduct);
    else if (
      selectedChemicalProduct &&
      (selectedChemicalProduct.id == -1 || !selectedChemicalProduct.id)
    )
      props.getNewChemicalProduct(selectedChemicalProduct.id);
    else if (selectedChemicalProduct) props.getChemicalProduct(selectedChemicalProduct.id);
  };

  const getWarning = newChemProdSelected => {
    const { values, t } = props;
    let isChemProdSelectedEmpty =
      !values.chemicalProduct.selectedChemicalProduct ||
      !values.chemicalProduct.selectedChemicalProduct.id;
    let warning = { parts: [] };
    if (newChemProdSelected) {
      warning.msg =
        'chemical.product.details.page.chemical.container.currently.creating.new.chemical.product.warning';
      warning.parts.push(
        <div key="select.existing.chemical.product.button">
          <a href="" onClick={e => onProgrammaticallyChemicalProductChange(e, null)}>
            {t(
              'chemical.product.details.page.chemical.container.select.existing.chemical.product.button'
            )}
          </a>
        </div>
      );
    } else if ((!newChemProdSelected && !isChemProdSelectedEmpty) || isChemProdSelectedEmpty) {
      if (initSelectors.isInventoryOrChemProductCanCreate(user, entityType.product))
        warning.parts.push(
          <div key="create.new.chemical.product.button">
            <a href="" onClick={e => onProgrammaticallyChemicalProductChange(e, -1)}>
              {t(
                'chemical.product.details.page.chemical.container.create.new.chemical.product.button'
              )}
            </a>
          </div>
        );
      if (isChemProdSelectedEmpty)
        warning.msg =
          'chemical.product.details.page.chemical.container.select.existing.chemical.product.warning';
      else {
        warning.msg =
          'chemical.product.details.page.chemical.container.currently.using.existing.chemical.product.warning';
        warning.params = { tradeName: values.chemicalProduct.tradeName };
        if (initSelectors.isInventoryOrChemProductCanCreate(user, entityType.product))
          warning.parts.push(
            <div key="clone.current.chemical.product.button">
              <a href="" onClick={e => onProgrammaticallyChemicalProductChange(e, -1, true)}>
                {t(
                  'chemical.product.details.page.chemical.container.clone.current.chemical.product.button'
                )}
              </a>
            </div>
          );
      }
    }
    return (
      <Message color="yellow">
        <>
          {t(warning.msg, warning.params)}
          {warning.parts}
        </>
      </Message>
    );
  };

  const renderSuggestionAddition = obj => {
    return (
      <div>
        {obj.state && (
          <Label size="tiny">
            {t('chemical.product.details.page.chemical.container.state.input.label')}
            <Label.Detail>{t(obj.state.name)}</Label.Detail>
          </Label>
        )}
        {obj.supplier && (
          <Label size="tiny">
            {t('chemical.product.details.page.chemical.container.supplier.input.label')}
            <Label.Detail>{obj.supplier.name}</Label.Detail>
          </Label>
        )}
        {obj.purity && (
          <Label size="tiny">
            {t('chemical.product.details.page.chemical.other.container.purity.input.label')}
            <Label.Detail>{obj.purity}</Label.Detail>
          </Label>
        )}
        <>
          {obj.hazards &&
            obj.hazards.map(h => (
              <img
                src={getHazardIconPath(h.id)}
                key={obj.is + '-' + h.id}
                height="20"
                className="hazardCell"
                style={{ verticalAlign: 'middle' }}
                alt="hazard"
              />
            ))}
        </>
        {obj.validateDte && (
          <Label size="tiny" basic color="green" style={{ float: 'right' }}>
            <Icon name="check" />
            {t('chemical.product.details.page.validate.inf.container.title.with.date', {
              date: moment(obj.validateDte).format(defaultDateFormatJustDate),
            })}
          </Label>
        )}
      </div>
    );
  };

  const getChemicalProductSelectedFieldConditionally = () => {
    const { values, disabled, isChemProdRouter, mode, currentStep } = props;
    if (isChemProdRouter || mode == VIEW_MODE) return null;
    let newChemProdSelected =
      values.chemicalProduct.selectedChemicalProduct &&
      values.chemicalProduct.selectedChemicalProduct.id === -1;

    return (
      <>
        {!newChemProdSelected && (
          <GridColumnInputWrapper
            {...props}
            name="chemicalProduct.selectedChemicalProduct"
            label="chemical.product.details.page.chemical.container.search.trade.name.input"
            render={props => (
              <CommonTagsInputWrapper
                {...props}
                value={values.chemicalProduct.selectedChemicalProduct}
                dynamicSuggestionListActionWithName={filterActions.getAutoCompleteSuggestionsList.bind(
                  this,
                  true
                )}
                dynamicSuggestionName="EXCLUDED_GEN_TRADE_CHEMICAL_NAMES"
                matchProperty="id"
                displayProps="tradeName,chemicalName"
                maxTags={1}
                disabled={disabled}
                onSelect={onChemicalProductChange}
                autoFocus={mode === CREATE_MODE && currentStep === 1}
                renderSuggestionAddition={renderSuggestionAddition}
              />
            )}
          />
        )}
        {(mode != CREATE_MODE || currentStep === 1) && (
          <Grid.Column>{getWarning(newChemProdSelected)}</Grid.Column>
        )}
      </>
    );
  };

  const getChemicalContainerContent = () => {
    return (
      <>
        <Grid doubling columns={1} verticalAlign="bottom">
          {getChemicalProductSelectedFieldConditionally()}
        </Grid>
      </>
    );
  };
  return (
    <AccordionWrapper
      {...props}
      accordionTitle="chemical.product.details.page.select.chemical.container.title"
      render={getChemicalContainerContent}
      className="containerReducedWhiteSpace"
      closable={false}
    />
  );
};

const mapDispatchToProps = dispatch => ({
  getChemicalProduct: id => dispatch(chemicalProductsActions.getChemicalProduct(id)),
  getNewChemicalProduct: id => dispatch(chemicalProductsActions.getNewChemicalProduct(id)),
  getNewChemicalProductFromCurrent: id =>
    dispatch(chemicalProductsActions.getNewChemicalProductFromCurrent(id)),
});

export default connect(null, mapDispatchToProps)(CPSelectChemicalContainer);
